export default function handleImageAlt(payload, defaultAlt = 'image') {
  if (typeof payload === 'object') {
    return payload.alt ?? 'image';
  }

  return defaultAlt;
}
